import { requestStateData } from './requestStateData'
import { useStateData } from './useStateData'
import { SignupState } from '../types'

export const fetchSettings = () =>
  requestStateData(
    'settings',
    ({ signupSession: { instantInkService }, localization }: SignupState) =>
      instantInkService.fetchSettings(
        localization?.language,
        localization?.country
      )
  )

export const useSettings = () =>
  useStateData('settings', fetchSettings, () => true)
